<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">

  <div class="title">
    <img
      class="logo"
      height="80"
      width="250"
      src="/images/logo.svg"
      alt="Sunset Grill logo">
    Follow Us!
  </div>

  <div class="links">
    <div class="link">
      <app-qrcode
        content="https://oon.gl/Z4VG7E/"
        logo='/images/instagram.svg'
        [size]="230"
      />
      <span class="label">
        &#64;sunsetgrill
      </span>
    </div>
    <div class="link">
      <app-qrcode
        content="https://oon.gl/PTPStR"
        logo='/images/facebook.svg'
        [size]="230"
      />
      <span class="label">
        /SunsetGrillBreakfast
      </span>
    </div>
  </div>

</div>


